export default function PageHero({ eyebrow, title, subtitle }) {
  return (
    <section className="bg-nkf-blue text-white relative overflow-hidden">
      <div className="absolute inset-0 diagonal-stripes" />
      <div className="absolute -bottom-32 -right-32 w-[360px] h-[360px] rounded-full bg-nkf-gold/10 blur-3xl" />
      <div className="nkf-container relative py-14 md:py-20">
        {eyebrow && <div className="text-[11px] uppercase tracking-[0.3em] text-nkf-gold font-semibold">{eyebrow}</div>}
        <h1 className="font-display text-3xl md:text-5xl lg:text-6xl mt-2 leading-tight">{title}</h1>
        {subtitle && <p className="mt-4 text-white/80 max-w-3xl text-base md:text-lg leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
